import React, { useMemo } from 'react';

import { GridEntityConfig } from '../grid-types';
import { useLevelIndex } from './level-index-hook';

const DefaultActionButtons = () => <></>;

export const useActionButtons = (gridConfig?: GridEntityConfig[]) => {
  const levelIndex = useLevelIndex(gridConfig);

  return useMemo(() => {
    if (levelIndex === undefined || !gridConfig) {
      return DefaultActionButtons;
    }

    const ActionButtons =
      gridConfig[levelIndex]?.ActionButtons ?? DefaultActionButtons;

    return ActionButtons;
  }, [gridConfig, levelIndex]);
};
